import type { HiddenLanes } from './map'

interface HiddenAccountsProps {
  hidden: HiddenLanes
  onShowAll: () => void
}

const counted = (count: number, one: string, many: string) =>
  count > 0 ? [`${count.toLocaleString()} ${count === 1 ? one : many}`] : []

// A member card is named apart, since it is a second card on an account, not an account.
const whatIsHidden = (hidden: HiddenLanes) =>
  [
    ...counted(hidden.accounts, 'account', 'accounts'),
    ...counted(hidden.memberCards, 'member card', 'member cards'),
  ].join(' and ')

// A filtered map must say it is filtered, or a hidden account reads as an account that is gone.
export const HiddenAccounts = ({ hidden, onShowAll }: HiddenAccountsProps) => (
  <p
    data-hidden-accounts
    className="shrink-0 whitespace-nowrap text-xs tabular-nums text-ink-subtle"
  >
    {whatIsHidden(hidden)} hidden.{' '}
    <button
      type="button"
      onClick={onShowAll}
      className="cursor-pointer font-medium text-foreground underline decoration-neutral-300 underline-offset-2 hover:decoration-foreground"
    >
      Show all
    </button>
  </p>
)
